import type { CSSObject } from 'styled-components';

import type Theme from '../types/theme';
import type { Color } from '../types/theme';

const getScrollbarColor = (color: Color, isDark?: boolean) => {
  if (isDark) {
    return `${color.background.reversed.hover()} ${color.background.reversed.default()}`;
  }

  return `${color.background.tertiary.default()} ${color.background.primary.default()}`;
};

export const scrollbar = (theme: Theme, isDark?: boolean): CSSObject => {
  const { size, color } = theme;

  return {
    '&::-webkit-scrollbar': {
      height: size.units(0.75),
      width: size.units(0.75),
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'none',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: color.background.tertiary.default(),
      borderRadius: '3px',
    },
    scrollbarWidth: 'thin',
    scrollbarColor: getScrollbarColor(color, isDark),
  };
};

export const hideScrollbar = (): CSSObject => {
  return {
    '-ms-overflow-style': 'none',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  };
};
